// hooks/useAuth.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const API_BASE_URL = 'http://localhost:5000/api';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      try {
        setUser(JSON.parse(userData));
        setIsAuthenticated(true);
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
  }, []);

  const login = async (credentials) => {
    try {
      setLoading(true);
      console.log('🔐 Attempting login with:', credentials.username);
      
      // ✅ Direct API call
      const response = await axios.post(`${API_BASE_URL}/login`, credentials);
      
      console.log('✅ Login Response:', response.data);
      
      if (response.data && response.data.token) {
        // Save token and user data
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        setUser(response.data.user);
        setIsAuthenticated(true);
        
        toast.success('Welcome back! 🎉');
        
        // ✅ Force navigation
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 100);
        
        return response.data;
      } else {
        throw new Error('No token received');
      }
    } catch (error) {
      console.error('❌ Login error:', error);
      
      if (error.response) {
        // Server responded with error
        toast.error(error.response.data?.error || 'Invalid credentials');
      } else if (error.request) {
        // No response from server
        toast.error('Server not responding. Please try again.');
      } else {
        // Other error
        toast.error('Login failed. Please try again.');
      }
      
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
    toast.success('Logged out successfully!');
    navigate('/login');
  };

  return {
    user,
    loading,
    isAuthenticated,
    login,
    logout,
  };
};